module.exports = __webpack_public_path__ + "static/media/app-mockup.36452556.png";